import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import * as _ from 'lodash';;
import { FilterService } from 'src/app/services/filter.service';
import { TaskpanelService } from 'src/app/components/direct/service/taskpanel.service';
import { FollowupPopupComponent } from '../follow-up-popup/follow-up-popup.component';

@Component({
  selector: 'app-patients-action-notes',
  template: `
  
  <div class="d-flex align-items-center justify-content-center" style="gap: 5px;">
    <!-- Chat -->
    <!-- <span>
      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="1" y="1" width="26" height="26" rx="13" fill="white" stroke="#E8EAEE" stroke-width="2"/>
        <path d="M19.4921 8.31966C19.5032 8.27301 19.5007 8.22414 19.4848 8.17889C19.4689 8.13364 19.4403 8.09392 19.4025 8.06445C19.3646 8.03499 19.3191 8.01704 19.2713 8.01273C19.2236 8.00842 19.1756 8.01794 19.1331 8.04016L8.89158 13.4102C8.77826 13.4699 8.68264 13.5584 8.61431 13.6667C8.54598 13.7751 8.50735 13.8995 8.50228 14.0275C8.49722 14.1555 8.5259 14.2826 8.58545 14.396C8.645 14.5094 8.73333 14.6052 8.84158 14.6737L11.1216 16.1147C11.1445 16.1292 11.1715 16.1359 11.1986 16.1338C11.2256 16.1316 11.2513 16.1207 11.2716 16.1027L17.3501 10.6687C17.3732 10.6467 17.4038 10.6345 17.4357 10.6345C17.4676 10.6345 17.4982 10.6467 17.5213 10.6686C17.5445 10.6906 17.5583 10.7205 17.56 10.7523C17.5618 10.7841 17.5512 10.8154 17.5306 10.8397L12.6731 16.9327C12.6621 16.9464 12.6542 16.9623 12.6498 16.9793C12.6455 16.9963 12.6447 17.014 12.6476 17.0313C12.6505 17.0486 12.6571 17.0651 12.6668 17.0798C12.6765 17.0944 12.6892 17.1068 12.7041 17.1162L15.9201 19.1507C16.0179 19.2123 16.1291 19.2498 16.2444 19.2598C16.3596 19.2699 16.4756 19.2523 16.5827 19.2086C16.6898 19.1648 16.7849 19.0961 16.8601 19.0082C16.9353 18.9203 16.9884 18.8157 17.0151 18.7032L19.4921 8.31966Z" fill="#1363DF"/>
      </svg>
    </span> -->
    <span *ngIf="this.params.data?.['pdrp_restricted_flg'] != 'Y'" (click)="patientNotes()" style="cursor: pointer;" [matTooltip]="'Notes'" svgIcon="notification_notes" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRightIndividualView"  aria-controls="offcanvasRightIndividualView">
      <!-- Note -->
      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="1" y="1" width="26" height="26" rx="13" fill="white" stroke="#E8EAEE" stroke-width="2"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M18.8 15.8V9.2H9.2V18.8H15.8V17C15.8 16.3373 16.3373 15.8 17 15.8H18.8ZM18.5515 17H17V18.5515L18.5515 17ZM9.2 20C8.53726 20 8 19.4627 8 18.8V9.2C8 8.53726 8.53726 8 9.2 8H18.8C19.4627 8 20 8.53726 20 9.2V17.2485L17.2485 20H9.2ZM11 17V15.8H14.6V17H11ZM11 14.6V13.4H17V14.6H11ZM11 12.2V11H17V12.2H11Z" fill="#1363DF"/>
      </svg>
    </span>
    <span *ngIf="this.params.data?.['pdrp_restricted_flg'] == 'Y'" style="cursor: not-allowed;" [matTooltip]="'PDRP Restricted'" svgIcon="notification_notes" >
      <!-- Note -->
      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="1" y="1" width="26" height="26" rx="13" fill="white" stroke="#E8EAEE" stroke-width="2"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M18.8 15.8V9.2H9.2V18.8H15.8V17C15.8 16.3373 16.3373 15.8 17 15.8H18.8ZM18.5515 17H17V18.5515L18.5515 17ZM9.2 20C8.53726 20 8 19.4627 8 18.8V9.2C8 8.53726 8.53726 8 9.2 8H18.8C19.4627 8 20 8.53726 20 9.2V17.2485L17.2485 20H9.2ZM11 17V15.8H14.6V17H11ZM11 14.6V13.4H17V14.6H11ZM11 12.2V11H17V12.2H11Z" fill="#ddd"/>
      </svg>
    </span>
    <!-- Task Icon  for Task Management-->
    <span class="task-icon-btn" *ngIf="this.displayCaseIcon" style="cursor: pointer; display: inline-flex; align-items: center;"
      (click)="openTaskPanel()" [matTooltip]="'Case'">
      <span [ngStyle]="{
              color: (caseVariableReplaced > 0) ? '#1E7E45' : '#6B7280',
              background: (caseVariableReplaced > 0) ? '#E6F4EA' : '#F2F3F5',
              border: (caseVariableReplaced > 0) ? '1px solid #A8DAB5' : '1px solid #DADCE0'
            }"
            style="display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 4px 10px; border-radius: 8px; font-size: 13px; font-weight: 600; line-height: 1;">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 7V5C8 4.46957 8.21071 3.96086 8.58579 3.58579C8.96086 3.21071 9.46957 3 10 3H14C14.5304 3 15.0391 3.21071 15.4142 3.58579C15.7893 3.96086 16 4.46957 16 5V7M12 12V12.01M3 9C3 8.46957 3.21071 7.96086 3.58579 7.58579C3.96086 7.21071 4.46957 7 5 7H19C19.5304 7 20.0391 7.21071 20.4142 7.58579C20.7893 7.96086 21 8.46957 21 9V18C21 18.5304 20.7893 19.0391 20.4142 19.4142C20.0391 19.7893 19.5304 20 19 20H5C4.46957 20 3.96086 19.7893 3.58579 19.4142C3.21071 19.0391 3 18.5304 3 18V9Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M3 13C5.79158 14.4067 8.87403 15.1394 12 15.1394C15.126 15.1394 18.2084 14.4067 21 13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        {{caseVariableReplaced || 0}}
      </span>
    </span>
    <!-- <span class="task-icon-btn" *ngIf="this.displayCaseIcon" style="cursor: pointer; display: inline-flex; align-items: center;"
      (click)="openTaskPanel()" [matTooltip]="'Cases'">
      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="1" y="1" width="26" height="26" rx="13" fill="white" stroke="#E8EAEE" stroke-width="2"/>
        <path d="M10.5 14.5L12.5 16.5L17.5 11.5" stroke="#1363DF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M19 14V18.2C19 18.88 19 19.22 18.873 19.482C18.7603 19.7132 18.5806 19.8977 18.3549 20.0131C18.1004 20.1429 17.7669 20.1429 17.1 20.1429H10.9C10.2331 20.1429 9.8996 20.1429 9.64509 20.0131C9.41937 19.8977 9.23969 19.7132 9.12698 19.482C9 19.22 9 18.88 9 18.2V12C9 11.32 9 10.98 9.12698 10.718C9.23969 10.4868 9.41937 10.3023 9.64509 10.1869C9.8996 10.0571 10.2331 10.0571 10.9 10.0571H14" stroke="#1363DF" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M19 8V11M20.5 9.5H17.5" stroke="#1363DF" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </span> -->
    <!-- Menu dot -->
    <!-- <span>
      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="1" y="1" width="26" height="26" rx="13" fill="white" stroke="#E8EAEE" stroke-width="2"/>
        <path d="M15.5 9.5C15.5 8.67157 14.8284 8 14 8C13.1716 8 12.5 8.67157 12.5 9.5C12.5 10.3284 13.1716 11 14 11C14.8284 11 15.5 10.3284 15.5 9.5Z" fill="#1363DF"/>
        <path d="M12.5 14C12.5 13.1716 13.1716 12.5 14 12.5C14.8284 12.5 15.5 13.1716 15.5 14C15.5 14.8284 14.8284 15.5 14 15.5C13.1716 15.5 12.5 14.8284 12.5 14Z" fill="#1363DF"/>
        <path d="M12.5 18.5C12.5 17.6716 13.1716 17 14 17C14.8284 17 15.5 17.6716 15.5 18.5C15.5 19.3284 14.8284 20 14 20C13.1716 20 12.5 19.3284 12.5 18.5Z" fill="#1363DF"/>
      </svg>
    </span> -->
  </div>
  `
})
export class PatientsActionNotesComponent implements ICellRendererAngularComp {

  // Variables
  params!: ICellRendererParams | any;
  annotationIndication = false;
  displayCaseIcon = false;
  caseVariableReplaced = 0;

  constructor(
    private filterService: FilterService,
    private taskPanelService: TaskpanelService
  ) { }

  refresh(): boolean {
    return false;
  }

  agInit(params: ICellRendererParams<any>): void {
    this.params = params;
    let cfg = this.params?.colDef?.configuration || {};
    this.displayCaseIcon = cfg.displayCaseIcon || false;
    this.caseVariableReplaced = this.params?.data?.[cfg?.caseVariableReplaced] || 0;
  }

  patientNotes() {
    let uniq = this.params.colDef.configuration.uniq_key;
    if (this.params?.data?.[uniq.payloadKey] || this.params?.data?.[uniq.payloadKey1]) {
      this.filterService.individualSelectedData = {
        key: this.params.data[uniq.payloadKey],
        value: this.params.data,
        dashboardKey: uniq.dashboardKey,
        config: uniq
      }
    } else {
      this.filterService.individualSelectedData = '';
    }
  }

  /** Open the global case sidebar (GlobalCaseSidebarComponent, hosted in the
   *  topnav) in "patient cases" mode. The embedded board loads only this
   *  entity's cases via the tag filter: `tag_id` is the row's patient_id (or
   *  hcp_npi_number) and `tag_category_id` is 1. */
  openTaskPanel() {
    let cfg = this.params?.colDef?.configuration || {};

    const data = this.params?.data || {};
    const tagId = data[cfg?.caseVariable] || data['du_patient_id'] || data['hcp_npi_number'] || null;
    const tagCategoryId = cfg?.caseCtgyVariable;

    // Display label for the auto-filled tag in the Create-Case dialog:
    //   • Prescriber (category 2) → prescriber name (prescriber_nm)
    //   • Patient    (category 1) → the patient id itself is the label
    const tagName = (Number(tagCategoryId) === 2 || Number(tagCategoryId) === 2002)
      ? (data['prescriber_name'] || data['prescriber_nm'] || tagId)
      : tagId;

    this.taskPanelService.openCaseSidebar({
      tag_id: tagId,
      tag_category_id: tagCategoryId,
      tag_name: tagName,
    });
  }
}